import ReactGA from 'react-ga4'
import type Keycloak from 'keycloak-js'

const reactGA = (
  typeof (ReactGA as { initialize?: unknown })?.initialize === 'function'
    ? ReactGA
    : (ReactGA as unknown as { default: typeof ReactGA }).default
) as typeof ReactGA

export interface KeycloakUserInfo {
  sub: string
  name?: string
  email?: string
  [key: string]: unknown
}

export const initAnalytics = (
  kcInstance: Keycloak,
  analyticsCode?: string
): void => {
  if (!analyticsCode) {
    console.warn(
      'Analytics desabilitado: código de rastreamento não fornecido.'
    )
    return
  }
  const keycloakId = kcInstance.tokenParsed?.sub

  if (!keycloakId) {
    console.warn(
      'Analytics desabilitado: Informações do usuário não disponíveis no token.'
    )
    return
  }

  const realm = kcInstance.realm

  if (!realm) {
    console.warn(
      'Analytics desabilitado: Informações do realm não disponíveis no token.'
    )
    return
  }

  try {
    reactGA.initialize(analyticsCode, {
      gaOptions: {
        userId: keycloakId,
        realm
      },
      gtagOptions: {
        send_page_view: false,
        user_properties: {
          keycloakId,
          realm
        }
      }
    })
  } catch (e) {
    console.error('Falha ao habilitar o Analytics:\n', e)
  }
}
